import { AnimatePresence, motion } from "framer-motion"
import React, { useState } from "react"
import { useTranslation } from "react-i18next"
import PriceFilter from "./PriceFilter"
import Duration from "./Duration"
import Countries from "./Countries"
import Airports from "./Airports"
import Airlines from "./Airlines"
import { RotateCcw, X } from "lucide-react"

const MobileFiltersModal = ({
  filters,
  priceRange,
  foundCurrency,
  countries,
  airports,
  airlines,
  initialSelectedCountryIds,
  initialSelectedAirportIds,

  // Handlers
  onChange,
  handleCountryChange,
  handleAirportChange,
  handleResetFilters,
}) => {
  const { t } = useTranslation()
  const [isOpen, setIsOpen] = useState(false)

  const applyFilters = () => {
    setIsOpen(false)
  }

  const resetAndClose = () => {
    handleResetFilters({
      resetCountries: () => handleCountryChange("reset"),
      resetAirports: () => handleAirportChange("reset"),
    })
  }

  return (
    <>
      <button
        onClick={() => setIsOpen(true)}
        className="xl:hidden fixed bottom-4 right-4 bg-second-success text-white px-6 py-3 rounded-full shadow-lg z-50 hover:bg-success transition-colors font-medium"
      >
        {t("admin.filters")}
      </button>

      {/* Overlay */}
      <AnimatePresence>
        {isOpen && (
          <>
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              onClick={() => setIsOpen(false)}
              className="xl:hidden fixed inset-0 bg-black/50 z-50"
            />

            {/* Модальное окно */}
            <motion.div
              initial={{ y: "100%" }}
              animate={{ y: 0 }}
              exit={{ y: "100%" }}
              transition={{ type: "spring", damping: 30, stiffness: 300 }}
              className="xl:hidden fixed bottom-0 left-0 right-0 bg-white z-50 rounded-t-2xl max-h-[90vh] flex flex-col"
            >
              {/* Заголовок */}
              <div className="sticky top-0 bg-white border-b border-gray-200 px-4 py-3 flex items-center justify-end rounded-t-2xl">
                {/* <h2 className="text-lg font-semibold">
                  {t("admin.filter_results") || "Отфильтровать результаты"}
                </h2> */}
                <button
                  onClick={() => setIsOpen(false)}
                  className="p-2 hover:bg-gray-100 rounded-full transition-colors"
                >
                  <X className="w-6 h-6" />
                </button>
              </div>

              {/* Контент фильтров */}
              <div className="flex-1 overflow-y-auto px-4 py-4">
                <PriceFilter
                  priceRange={priceRange}
                  min={filters.price.min}
                  max={filters.price.max}
                  currency={foundCurrency}
                  onChange={onChange}
                />

                <Duration
                  duration={filters.flightDuration}
                  title={t("admin.flight_duration_v2")}
                  onChange={onChange}
                  t={t}
                />

                <Countries
                  countries={countries}
                  onChange={handleCountryChange}
                  initialSelectedCountryIds={initialSelectedCountryIds}
                />

                <Airports
                  airports={airports}
                  initialSelectedCountryIds={initialSelectedAirportIds}
                  onChange={handleAirportChange}
                />

                <Airlines
                  selectedCodes={filters.airlinesCodes}
                  airlines={airlines}
                  onChange={onChange}
                />
              </div>

              {/* Кнопки внизу */}
              <div className="sticky bottom-0 bg-white border-t border-gray-200 p-4 flex gap-3">
                <button
                  onClick={resetAndClose}
                  className="flex-1 py-3 border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors font-medium flex items-center justify-center gap-2"
                >
                  <RotateCcw size={18} />
                  <span>{t("admin.reset")}</span>
                </button>
                <button
                  onClick={applyFilters}
                  className="flex-1 py-3 bg-second-success text-white rounded-lg hover:bg-success transition-colors font-medium"
                >
                  {t("admin.apply")}
                </button>
              </div>
            </motion.div>
          </>
        )}
      </AnimatePresence>
    </>
  )
}

export default MobileFiltersModal
